import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { UserData } from '@chefami-monorepo/types';

@Component({
  selector: 'lib-centered-header',
  imports: [NgOptimizedImage],
  templateUrl: './centered-header.component.html',
  styleUrl: './centered-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CenteredHeaderComponent {
  options = input.required<UserData>();

  // Computed values for easy template access
  isLoggedIn = computed(() => this.options().isLoggedIn);
  userInfo = computed(() => this.options().userInfo);
  siteInfo = computed(() => this.options().siteInfo);

  // Computed for logo URL from siteInfo
  logoUrl = computed(() => this.siteInfo()?.site_url || '/');
}
